import {
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD,
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT,
} from '../../Entity'

export const NewsboardPostProfileHeaderInfoItemName = {
  Comments: 'comments',
  PostAge: 'postAge',
  TimeRange: 'timeRange',
  Type: 'type',
}

export const NEWSBOARD_POST_PROFILE_HEADER_INFO_ITEM_ACTIONS_PROPS = {
  [NewsboardPostProfileHeaderInfoItemName.TimeRange]: {
    buttonsProps: {
      [ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD]: {
        tooltip: 'NewsboardPostProfile.AddTimeRangeBtnTooltipKey',
      },
      [ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT]: {
        tooltip: 'NewsboardPostProfile.EditTimeRangeBtnTooltipKey',
      },
    },
  },
}

export const NEWSBOARD_POST_PROFILE_HEADER_INFO_ITEM_TITLE_KEYS = {
  [NewsboardPostProfileHeaderInfoItemName.Comments]:
    'Newsboard.FormCommentsFieldLabelKey',
  [NewsboardPostProfileHeaderInfoItemName.PostAge]:
    'NewsboardPostProfile.HeaderPostAgeLabelKey',
  [NewsboardPostProfileHeaderInfoItemName.TimeRange]:
    'NewsboardPostProfile.HeaderTimeRangeLabelKey',
  [NewsboardPostProfileHeaderInfoItemName.Type]:
    'NewsboardPostProfile.HeaderTypeLabelKey',
}

export const NEWSBOARD_POST_PROFILE_HEADER_INFO_ITEMS_LOADING_ITEMS_LENGTH = 3

export const NEWSBOARD_POST_PROFILE_HEADER_INFO_ITEMS_MAX_ITEMS_IN_ROW = 2
